import { DEFAULT_LANG } from '@/constants/locales'

import { formatNumberWithCommas as funnowFormatNumberWithCommas } from '@myfunnow/web-core'

export const formatNumberWithCommas = (value: number | string = 0, lang = DEFAULT_LANG) => {
  return funnowFormatNumberWithCommas(value, lang)
}
